var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginBg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    viewBox: "0 0 960 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_83_17",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 960,
    height: 1080
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 1080,
    fill: "#1E293B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_83_17)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 1080,
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.00012207,
    cy: -0.595581,
    r: 440.068,
    stroke: "#242F41",
    strokeWidth: 184
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 960,
    cy: 976,
    r: 440.068,
    stroke: "#242F41",
    strokeWidth: 184
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg2);
export default __webpack_public_path__ + "static/media/loginBg2.c2fec37dd51b6460b8b5dd21dfdf41a6.svg";
export { ForwardRef as ReactComponent };